import { API_ENDPOINTS } from '../../../config/api';
import { authHeaders, formatGuideDate, getPlaceholderSwatch, truncateGuideTitle } from '../guidesUtils';

export { authHeaders, formatGuideDate, getPlaceholderSwatch, truncateGuideTitle };

export async function flashcardsFetch(path, options = {}) {
  const res = await fetch(`${API_ENDPOINTS.FLASHCARDS}${path}`, options);
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data.message || 'Request failed');
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

export function stripHtmlToText(html) {
  if (!html) return '';
  const div = document.createElement('div');
  div.innerHTML = html;
  return (div.textContent || '').replace(/\u00a0/g, ' ').trim();
}

/** known|correct ÷ attempted — works for review and test; backfills missing scorePercent */
export function resolveAttemptScore(attempt) {
  if (!attempt) return null;
  if (attempt.scorePercent != null && !Number.isNaN(Number(attempt.scorePercent))) {
    return Number(attempt.scorePercent);
  }
  const attempted = Number(attempt.cardsAttempted) || 0;
  const knownOrCorrect = Number(attempt.correctCount) || 0;
  if (attempted <= 0) return null;
  return Math.round((knownOrCorrect / attempted) * 1000) / 10;
}

export function isCardSideEmpty(html) {
  if (!html) return true;
  const div = document.createElement('div');
  div.innerHTML = html;
  const text = (div.textContent || '').replace(/\u00a0/g, ' ').trim();
  if (text) return false;
  return !div.querySelector('img, table, iframe, video, hr');
}

export function shuffleArray(items) {
  const arr = [...items];
  for (let i = arr.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}

export function formatAttemptDate(value) {
  if (!value) return '—';
  try {
    return new Date(value).toLocaleString(undefined, {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit'
    });
  } catch {
    return '—';
  }
}
